/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaSelectOne from 'DesignSystem/TysiaSelectOne/index'
import TysiaSelectOneArrow from 'DesignSystem/TysiaSelectOne/TysiaSelectOneArrow/index'
import TysiaSelectOneContent from 'DesignSystem/TysiaSelectOne/TysiaSelectOneContent/index'
import TysiaSelectOneInput from 'DesignSystem/TysiaSelectOne/TysiaSelectOneInput/index'
import TysiaSelectOneLabel from 'DesignSystem/TysiaSelectOne/TysiaSelectOneLabel/index'
import TysiaSelectOneOptions from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/index'
import TysiaSelectOnePopover from 'DesignSystem/TysiaSelectOne/TysiaSelectOnePopover/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/Data/DataVaxiom/DataVaxiomTxCardFieldDefinitions/DataVaxiomTxCardFieldDefinitionsCardWrite/Type/Content",
  onChange,
  isInvalid
  
}) {
let txCardFieldTypesValueData = fromData.useDataValue({ viewPath,
context: 'tx_card_field_types',
})
let txCardFieldDefinitionTypeIdValueData = fromData.useDataValue({ viewPath,
context: 'tx_card_field_definition',
path: 'type_id',
})
let txCardFieldDefinitionTypeIdIsValidData = fromData.useDataIsValid({ viewPath,
context: 'tx_card_field_definition',
path: 'type_id',
validate: fromValidate.number,
required: true,
})
let txCardFieldDefinitionTypeIdChangeData = fromData.useDataChange({ viewPath,
context: 'tx_card_field_definition',
path: 'type_id',
})
  return (<React.Fragment
>
<TysiaSelectOne
  viewPath={`${viewPath}/TysiaSelectOne`}
 size="medium"
 allowEmptyChoice={false}
 flexGrow={0}
 flexShrink={0}
 flexBasis="auto"
 data="tx_card_field_types"
 from={txCardFieldTypesValueData}
 data="tx_card_field_definition.type_id"
 value={txCardFieldDefinitionTypeIdValueData}
 onChange={txCardFieldDefinitionTypeIdChangeData}
 validate="/Data/validate.js number"
 invalid={!txCardFieldDefinitionTypeIdIsValidData}
 required={true}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneLabel`}
 text="Type"
/>
<TysiaSelectOneContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneContent`}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneInput
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneInput`}
/>
<TysiaSelectOneArrow
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneArrow`}
/>
<TysiaSelectOnePopover
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOnePopover`}
>
{childProps => (
<TysiaSelectOneOptions
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptions`}
/>
)}
</TysiaSelectOnePopover>
</React.Fragment>
)}
</TysiaSelectOneContent>
</React.Fragment>
)}
</TysiaSelectOne>
{children}
</React.Fragment>)
}